import { Box, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { CourierType } from 'const/CourierType';
import React, {
  ChangeEvent,
  createRef,
  useCallback,
  useEffect,
  useState,
} from 'react';

interface CourierSelectionProps {
  options: Array<CourierType>;
  onSelect: (selectedCourier: CourierType) => void;
}

export const CourierSelection = ({
  options,
  ...props
}: CourierSelectionProps) => {
  const [searchText, setSearchText] = useState('');
  const [selected, setSelected] = useState(false);

  const ref = createRef<HTMLDivElement>();

  const onSearchTextChanged = (_: ChangeEvent<unknown>, newValue: string) => {
    setSearchText(newValue);
  };

  const triggerClear = useCallback(() => {
    const clearButtonEl = ref.current.getElementsByClassName(
      'MuiAutocomplete-clearIndicator'
    )?.[0] as HTMLButtonElement;
    clearButtonEl?.click();
    setSelected(false);
  }, [ref]);

  /* Clear autocomplete after selection */
  useEffect(() => {
    selected && triggerClear();
  }, [selected, triggerClear]);

  return (
    <Autocomplete
      ref={ref}
      disableCloseOnSelect
      className="courier-selection"
      options={options}
      getOptionLabel={option => option.name}
      renderOption={(props, option) => (
        <Box {...props}>
          {props.name}
          <br />
          <small style={{ color: '#999' }}>{props.notes}</small>
        </Box>
      )}
      renderInput={params => (
        <TextField
          {...params}
          placeholder={`Select unassigned couriers (${options.length})`}
        />
      )}
      clearText="Remove all assigned couriers"
      inputValue={searchText}
      onInputChange={onSearchTextChanged}
      onChange={(e, value) => {
        e.preventDefault();

        /* This event will be called twice because of the `triggerClear` action */
        /* First have actual `Courier` value */
        /* Second have the cleared value */
        const selectedCourier = value as CourierType;
        selectedCourier && props.onSelect(selectedCourier);

        setSelected(true);
      }}
    />
  );
};
